import type { Member } from "common/types";

import RemoveMember from "../RemoveMember";
import UpdatePermissions from "../UpdatePermissions";
import ResendInvite from "./ResendInvite";
import RevokeInvite from "./RevokeInvite";

import type useMembersActions from "../../hooks/useMembersActions";

interface MemberActionsProps {
  member: Member;
  action: keyof ReturnType<typeof useMembersActions>["actions"];
  onClose: () => void;
  onBack: () => void;
}

export default function MemberActions({
  member,
  action,
  onClose,
  onBack,
}: MemberActionsProps) {
  if (action === "remove") {
    const { email, customer_id } = member;
    return (
      <RemoveMember
        email={email}
        memberCustomerId={customer_id}
        onBack={onBack}
      />
    );
  }
  if (action === "revoke") {
    const { token } = member;
    return <RevokeInvite inviteToken={token} onBack={onBack} />;
  }
  if (action === "permissions") {
    return (
      <UpdatePermissions member={member} onClose={onClose} onBack={onBack} />
    );
  }
  if (action === "resend") {
    const { token } = member;
    return (
      <ResendInvite inviteToken={token} onClose={onClose} onBack={onBack} />
    );
  }
}
